export default function IconPlayBig() {
  return (
    <svg width="56" height="48" viewBox="0 0 56 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.153 46.9416C14.6504 49.4239 11 47.3904 11 42.4033L11 5.60033C11 0.608208 14.6504 -1.42268 19.153 1.05727L52.6222 19.5052C57.1262 21.9883 57.1262 26.0115 52.6222 28.494L19.153 46.9416Z"
        fill="white" />
    </svg>
  );
}
